module.exports = __webpack_public_path__ + "img/Logo_Horizontal_Gradient_Dark_Transparent.f3e40039.svg";